import { render, staticRenderFns } from "./StockCategory.vue?vue&type=template&id=47e085c0&"
import script from "./StockCategory.vue?vue&type=script&lang=js&"
export * from "./StockCategory.vue?vue&type=script&lang=js&"
import style0 from "./StockCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports